import { http, HttpResponse } from 'msw'

import { allSiteTypes } from 'app/mocks/data/park/sites/types'

import {
    api,
    isNumeric,
    SEARCH_PARAM_LIMIT,
    SEARCH_PARAM_OFFSET,
} from 'app/utils/constants'
import { searchParametersSiteTypesApi } from 'app/utils/settings/siteTypes'

import { SiteTypeRequest } from 'app/types/park/site'

export const getAllSiteTypes = http.get(
    `${process.env.REACT_APP_API_ADDRESS}/${api.park.sites.types.LIST}`,
    ({ request }) => {
        const { searchParams } = new URL(request.url)
        const limitQuery = searchParams.get(SEARCH_PARAM_LIMIT)
        const offsetQuery = searchParams.get(SEARCH_PARAM_OFFSET)

        const managerId = searchParams.get(searchParametersSiteTypesApi.MANAGER)

        let allSiteTypesFiltered = allSiteTypes

        if (managerId) {
            allSiteTypesFiltered = allSiteTypesFiltered.filter(
                (zone) => zone.client.id.toString() === managerId,
            )
        }

        // Pagination
        const limit = isNumeric(limitQuery) ? Number(limitQuery) : 10
        const offset = isNumeric(offsetQuery) ? Number(offsetQuery) : 0

        const limitArray =
            allSiteTypesFiltered.length > limit
                ? offset + limit
                : allSiteTypesFiltered.length

        const results = allSiteTypesFiltered.slice(offset, limitArray)

        const next =
            offset + results.length < allSiteTypesFiltered.length
                ? 'again'
                : undefined

        return HttpResponse.json<SiteTypeRequest>({
            next,
            results,
        })
    },
)
